// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"3c2c0782","453":"96aaab2d","667":"4fb9d5c7","977":"d34cab20"}[chunkId] + ".chunk.js");